function AvatarStatusIndicator({ status, selectedVoice }) {
    try {
        if (!status) return null;

        const getStatusContent = () => {
            switch (status) {
                case 'preparing':
                    return {
                        icon: 'fa-cog',
                        title: '準備中',
                        message: '正在準備語音資產...'
                    };
                case 'uploading':
                    return {
                        icon: 'fa-cloud-upload-alt',
                        title: '上傳中',
                        message: '正在上傳語音資產到 HeyGen...'
                    };
                case 'success':
                    return {
                        icon: 'fa-check-circle',
                        title: '上傳成功',
                        message: '語音資產已成功上傳到 HeyGen'
                    };
                case 'error':
                    return {
                        icon: 'fa-exclamation-circle',
                        title: '上傳失敗',
                        message: '上傳語音資產失敗，請稍後再試'
                    };
                default:
                    return null;
            }
        };

        const content = getStatusContent();
        if (!content) return null;

        const isInProgress = status === 'preparing' || status === 'uploading';
        const bgColor = status === 'success' ? 'bg-green-50 border-green-200' : 
                       status === 'error' ? 'bg-red-50 border-red-200' : 
                       'bg-blue-50 border-blue-200';
        
        const textColor = status === 'success' ? 'text-green-700' : 
                         status === 'error' ? 'text-red-700' : 
                         'text-blue-700';
        
        const iconColor = status === 'success' ? 'text-green-500' : 
                         status === 'error' ? 'text-red-500' : 
                         'text-blue-500';

        return (
            <div className={`fixed bottom-6 right-6 p-4 rounded-lg shadow-lg border ${bgColor} max-w-sm z-50`} data-name="avatar-status-indicator">
                <div className="flex items-center mb-2">
                    <div className={`${iconColor} mr-3 ${isInProgress ? 'animate-spin' : ''}`}>
                        <i className={`fas ${content.icon} text-2xl`}></i>
                    </div>
                    <div>
                        <h3 className="font-medium">{content.title}</h3>
                        <p className={`text-sm ${textColor}`}>{content.message}</p>
                    </div>
                </div>
                {selectedVoice && (
                    <div className="mt-2 pt-2 border-t border-gray-200">
                        <div className="text-sm">
                            <span className="font-medium">語音:</span> {selectedVoice.voiceName}
                        </div>
                    </div>
                )}
            </div>
        );
    } catch (error) {
        console.error('AvatarStatusIndicator component error:', error);
        reportError(error);
        return null;
    }
}

export default AvatarStatusIndicator;